export default "__VITE_ASSET__C6SHJy3h__"